import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LogTrackingLinkComponent } from './log-tracking-link/log-tracking-link.component';
import { LogTrackingLandingComponent } from './log-tracking-landing/log-tracking-landing.component';

const routes: Routes = [
  {path:'',component:LogTrackingLinkComponent,
    children:[
      {
        path:'log_tracking',component:LogTrackingLandingComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LogtrackingRoutingModule { }
